// @flow
import { connect } from 'react-redux';

import ClosableDialog from './ClosableDialog';

const mapStateToProps = ({ browser }) => ({
  browser,
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClosableDialog);



// WEBPACK FOOTER //
// ./components/ClosableDialog/index.js